import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import { fetchOCR } from '../../api/demonstration';
import OcrCCDemonstration from './OcrCCDemonstration';

const CNCompositionCorrection = ({
  materialsPath,
  selectList,
  inputOption,
  initInfo,
  lang
}) => {
  const [result, setResult] = useState({});
  const [response, setReponse] = useState(null);
  const [request, setRequest] = useState(null);
  const [locationInfo, setLocationInfo] = useState([]);

  const handleCoordinate = (arr) => {
    return arr.map((item) => {
      return Object.values(item);
    });
  };

  const handleCorrectData = useCallback(
    (overall, highlight, gec_result, originText) => {
      const sentenceComment = () => {
        let results = [];
        let quote = [];
        let location = [];
        let temArrOne = [
          ...highlight.idiom.info,
          ...highlight.allegorical.info,
          ...highlight.quote.info
        ];
        let temArrTwo = [
          ...Object.values(highlight.rhetorical.info),
          ...Object.values(highlight.description.info)
        ];

        let temArrThree = [
          ...highlight.allegorical.info,
          ...highlight.quote.info
        ];

        temArrOne.forEach((item) => {
          const temObj = {};
          temObj.sentence_comment = item.sentence_comment;
          if (item.details !== []) {
            temObj.content = item.details.map((subItem) => {
              if (subItem.location_info !== []) {
                subItem.location_info.forEach((subSubItem) => {
                  location.push({
                    points: handleCoordinate(subSubItem.location),
                    result: 1,
                    type: 'line'
                  });
                });
              }
              return { content: subItem.content };
            });
          }
          if (temObj.sentence_comment) {
            let temArr = '';
            temArr = temObj.content
              .map((qitem) => {
                return qitem.content;
              })
              .join('、');
            results.push({
              ...temObj,
              content: temArr
            });
          }
        });

        temArrTwo.forEach((twoItem) => {
          if (Array.isArray(twoItem) && twoItem !== []) {
            twoItem.forEach((subTwoItem) => {
              if (
                subTwoItem.sentence_comment &&
                subTwoItem.location_info !== []
              ) {
                subTwoItem.location_info.forEach((subSubTwoItem) => {
                  location.push({
                    points: handleCoordinate(subSubTwoItem.location),
                    result: 1,
                    type: 'line'
                  });
                });
              }
              if (subTwoItem.sentence_comment) {
                results.push({
                  sentence_comment: subTwoItem.sentence_comment,
                  content: originText[subTwoItem.sentence_id].original_text
                });
              }
            });
          }
        });

        temArrThree.forEach((item) => {
          const temObj = {};
          temObj.sentence_comment = item.sentence_comment;
          if (item.details !== []) {
            temObj.content = item.details.map((subItem) => {
              if (subItem.location_info !== []) {
                subItem.location_info.forEach((subSubItem) => {
                  location.push({
                    points: handleCoordinate(subSubItem.location),
                    result: 1,
                    type: 'line'
                  });
                });
              }
              return { content: subItem.content };
            });
          }
          quote = quote.concat(temObj.content);
        });
        return { results, quote, location };
      };

      const idiomContent = () => {
        let idiom = [];
        if (highlight.idiom.info !== []) {
          highlight.idiom.info.forEach((item) => {
            if (item.details !== []) {
              item.details.forEach((subItem) => {
                idiom.push(subItem.content);
              });
            }
          });
        }
        return idiom.join('、');
      };
      const radius = (a, o) => {
        let lt = Math.sqrt((a[1].y - o.y) ** 2 + (o.x - a[1].x) ** 2);
        let rt = Math.sqrt((a[2].y - o.y) ** 2 + (a[2].x - o.x) ** 2);
        let lb = Math.sqrt((o.y - a[3].y) ** 2 + (o.x - a[3].x) ** 2);
        let rb = Math.sqrt((o.y - a[4].y) ** 2 + (a[4].x - o.x) ** 2);
        return Math.round(Math.max(...[lt, rt, lb, rb]));
      };

      const mistakeContent = () => {
        let mistakeLocation = [];
        let mistakeArr = [];
        if (gec_result.grammar_mistake_info.info !== []) {
          gec_result.grammar_mistake_info.info.forEach((item) => {
            if (item.details) {
              item.details.forEach((subitem) => {
                let temPosition = {
                  points: [subitem.location[0].x, subitem.location[0].y],
                  radius: radius(subitem.location, subitem.location[0]),
                  result: 1,
                  type: 'circular'
                };
                mistakeLocation.push(temPosition);
                mistakeArr.push({
                  content: subitem.origin + '——>' + subitem.corrected
                });
              });
            }
          });
        }
        return {
          mistake: mistakeArr,
          mistakeLocation
        };
      };

      const commentContent = sentenceComment();
      const mistake = mistakeContent();
      const locationArr =
        commentContent.location &&
        commentContent.location.concat(mistake.mistakeLocation);
      setLocationInfo(locationArr);

      const correctResult = {
        overall_score: {
          title: '【总分】',
          score: overall.total_score
        },
        overall_result: {
          title: '【总评语】',
          content: overall.total_comment
        },
        writing_highlight: {
          title: '【分项评分+评语】',
          content: [
            {
              title: '主题：',
              score: overall.category_score.theme.score + '分',
              content: overall.category_score.theme.comment
            },
            {
              title: '内容：',
              score: overall.category_score.content.score + '分',
              content: overall.category_score.content.comment
            },
            {
              title: '结构：',
              score: overall.category_score.organization.score + '分',
              content: overall.category_score.organization.comment
            },
            {
              title: '表达：',
              score: overall.category_score.expression.score + '分',
              content: overall.category_score.expression.comment
            },
            {
              title: '建议：',
              content: overall.total_suggestion
            },
            {
              title: '错字：',
              num:
                gec_result.grammar_mistake_info.grammar_mistake_statistic
                  .spell_errors + '个',
              content: mistake.mistake,
              color: 'red'
            },
            {
              title: '成语：',
              num: highlight.idiom.num + '个',
              content: idiomContent(),
              color: 'green'
            },
            {
              title: '引用：',
              num: commentContent.quote.length + '个',
              content: commentContent.quote,
              color: 'green'
            },
            {
              title: '句评：',
              num: commentContent.results.length + '个',
              content: commentContent.results,
              color: 'green'
            }
          ]
        }
      };
      return correctResult;
    },
    []
  );

  const changeLocationInfo = () => {
    setLocationInfo([]);
    setRequest(null);
    setReponse(null);
    setResult({});
  };

  const identifyingImg = (params) => {
    fetchOCR({ ...params })
      .then((data) => {
        setReponse(data);
        if (data.code === 20000) {
          const overall = data.data.overall_result;
          const highlight = data.data.writing_highlight;
          const gecResult = data.data.gec_result;
          const res = data.data.original_essay_info.original_sentence_list;
          const correctResult = handleCorrectData(
            overall,
            highlight,
            gecResult,
            res
          );
          const originTitle = data.data.original_essay_info.answer_title;
          const originContent =
            data.data.original_essay_info.original_paragraph_list;
          setResult({ originTitle, originContent } || {});
          setRequest(correctResult);
        }
      })
      .catch((err) => {
        Message.error(err.msg || err.message);
        setReponse({});
      });
  };

  return (
    <OcrCCDemonstration
      lang={lang}
      result={
        <ul>
          <li>
            <h3 style={{ textAlign: 'center' }}>{result.originTitle}</h3>
          </li>
          {result.originContent &&
            result.originContent.map((resultItem, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={resultItem + index} className="result_text">
                  <span>{resultItem}</span>
                </li>
              );
            })}
        </ul>
      }
      request={
        request ? (
          <div className="correct_result">
            <div className="correct_result_item">
              <div className="correct_result_title">
                {request.overall_score.title}
              </div>
              <div className="correct_result_text">
                {request.overall_score.score} 分
              </div>
            </div>
            <div className="correct_result_item">
              <div className="correct_result_title">
                {request.overall_result.title}
              </div>
              <div className="correct_result_text">
                {request.overall_result.content}
              </div>
            </div>
            <div className="correct_result_item">
              <div className="correct_result_title">
                {request.writing_highlight.title}
              </div>
              <div className="correct_result_text">
                {request.writing_highlight.content.map((rquestItem) => {
                  return (
                    <div
                      className="correct_result_text_item"
                      key={rquestItem.title}
                      style={{
                        color: rquestItem.color ? rquestItem.color : ''
                      }}
                    >
                      <div className="correct_result_text_title">
                        {rquestItem.title}{' '}
                        {rquestItem.num ? rquestItem.num : rquestItem.score}
                      </div>
                      {Array.isArray(rquestItem.content) ? (
                        rquestItem.content.map((subRquestItem, subIndex) => {
                          return (
                            // eslint-disable-next-line react/no-array-index-key
                            <div
                              className="correct_result_text_subitem"
                              key={subIndex + subRquestItem.content}
                            >
                              <div className="correct_result_text_subtitle">
                                {subIndex + 1}.{subRquestItem.content}
                              </div>
                              <div className="correct_result_text_subcontent">
                                {subRquestItem.sentence_comment}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="correct_result_text_subitem">
                          {rquestItem.content}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : null
      }
      response={response}
      handleIdentifyingImg={identifyingImg}
      changeLocationInfo={changeLocationInfo}
      materialsPath={materialsPath}
      selectList={selectList}
      inputOption={inputOption}
      initInfo={initInfo}
      location={locationInfo}
    />
  );
};

CNCompositionCorrection.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array,
    inputOption: PropTypes.object,
    initInfo: PropTypes.object
  })
};

export default CNCompositionCorrection;
